import { useState } from "react";
import "./styles.css";

import questions from "./questions";

let currentIndex = 0;

export default function App() {
  const [text, setText] = useState("Press Start to Begin");

  const setTheText = () => {
    const randomIndex = Math.floor(Math.random() * questions.length);
    setText(questions[randomIndex]);
  };

  const setPreviousText = () => {
    currentIndex = currentIndex - 1;
    setText(questions[currentIndex]);
  };

  const setNextText = () => {
    currentIndex = currentIndex + 1;
    setText(questions[currentIndex]);
  };

  return (
    <>
      <div className="result">
        <div>{text}</div>
      </div>

      <div class="controllers">
        <button className="start_button" onClick={() => setTheText()}>
          Start
        </button>
      </div>
    </>
  );
}
